import React, { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { site } from '../../configs/site';

const EventBanner = () => {
  // sessionStorage instead of localStorage: closing the banner now only
  // sticks for the current browser tab/session, so it comes back next
  // visit instead of staying dismissed forever on that device.
  const [visible, setVisible] = useState(
    () => sessionStorage.getItem('event-banner-closed') !== 'true'
  );

  const handleClose = () => {
    sessionStorage.setItem('event-banner-closed', 'true');
    setVisible(false);
  };

  if (!visible || !site.event.enabled) {
    return null;
  }

  return (
    <div className="relative w-full bg-[#07E3DC]">
      <div className="flex flex-col gap-4 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6 sm:px-6 sm:py-4 lg:px-6">
        <div className="flex flex-col items-center gap-3 text-center sm:flex-row sm:items-center sm:gap-4 sm:text-left">
          {/* On mobile the banner stacks in three levels: logo, then title,
              then description, all centered; the close button is pinned to
              the top-right corner so it doesn't pull the logo off-center.
              On sm+ screens the logo sits beside the text and the close
              button moves out to its own element on the far right (see
              below). */}
          <div className="flex items-center justify-center">
            <img
              src={site.event.logo}
              alt={site.event.logoAlt}
              className="h-20 w-auto shrink-0 sm:h-18"
            />

            <button
              type="button"
              onClick={handleClose}
              className="absolute right-2 top-2 rounded-md p-2 text-[#192323]/70 hover:bg-black/10 hover:text-[#192323] sm:hidden"
            >
              <span className="sr-only">Close banner</span>
              <XMarkIcon className="h-5 w-5" />
            </button>
          </div>

          <div className="min-w-0 flex-1">
            <h2 className="text-lg font-bold leading-tight tracking-tight text-[#192323] sm:text-2xl">
              {site.event.title}
            </h2>

            <p className="mt-1 text-sm text-[#192323] sm:text-base font-semibold">
              {site.event.description}
            </p>
          </div>
        </div>

        <button
          type="button"
          onClick={handleClose}
          className="hidden shrink-0 rounded-md p-2 text-[#192323]/70 hover:bg-black/10 hover:text-[#192323] sm:block"
        >
          <span className="sr-only">Close banner</span>
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default EventBanner;
